<div class="hero-container">
    <div class="hero-content">
       <h1>
          @if(header) {
            {{header}}
            <!-- <br> -->
          } 
          @if(primaryHeader){
            <span class="content-primary">{{primaryHeader}}</span>
            <!-- <br> -->
          }
          <span class="content-highlight">{{highlightHeader}}</span>
       </h1>
      <ul class="description">
        @for (item of description; track $index) {
          <li>{{item}}</li>
        }
      </ul>
      <div class="button-group">
        <button mat-raised-button color="primary" routerLink="/signin" class="full-width-mobile">
          Login
        </button>
        <button mat-flat-button color="primary" routerLink="/register" class="full-width-mobile">
          Sign Up
        </button>
      </div>
    </div>
  
    <div class="hero-image icon-no-shrink d-none d-md-flex">
    </div>
  </div>
  